import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/settings/community/$communityId/")({
  component: RouteComponent
});

function RouteComponent() {
  const params = Route.useParams();
  return <Navigate to={`${Route.fullPath}roles`} params={params} replace />;
}
